// extracted by mini-css-extract-plugin
export default {"apple-pay-button":"styles_apple-pay-button__qXCBz"};